import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { makeApiCall } from "../../helpers/postRequest";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { ERROR_MESSAGES } from "../../constants/enums";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { api } from "../../api/api";
import { IMPOI, IMPOIReport } from "./Mpoi.types";

export const FETCH_MPOI_LIST_PROGRESS = "FETCH_MPOI_LIST_PROGRESS";
export const FETCH_MPOI_LIST_SUCCESS = "FETCH_MPOI_LIST_SUCCESS";
export const FETCH_MPOI_LIST_FAILED = "FETCH_MPOI_LIST_FAILED";

export const fetchMpoiListProgress = () =>
  action(FETCH_MPOI_LIST_PROGRESS);
export const fetchMpoiListSuccess = (
  data: IMPOI[],
) =>
  action(FETCH_MPOI_LIST_SUCCESS, {
    data,
  });
export const fetchMpoiListFailed = () =>
  action(FETCH_MPOI_LIST_FAILED);

export const fetchMpoiListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    customerPolicyId?: number,
    policyType?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchMpoiListProgress());

      let finalUrl = `/mpoi/get-eslip-payload?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/mpoi/get-eslip-payload?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      if (policyType) {
        finalUrl += "&column=line_of_business&value=" + policyType;
      }

      if (customerPolicyId) {
        const filterObj = {
          column: ["customer_policy_id"],
          operator: "EQUAL",
          value: customerPolicyId,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += "&advanceFilter=" + encodedFilter;
      }
      const res = await makeApiCall({
        method: "GET",
        url: finalUrl,
      });
      const data: IMPOI[] = res.data.data;

      dispatch(fetchMpoiListSuccess(data));
    } catch (err: any) {
      dispatch(fetchMpoiListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  export const createMpoiReportAsync =
    (mpoi: IMPOI, fromDate: string, toDate: string, pageNumber: number, rowsInPerPage: number, onCallback: (isSuccess: boolean) => void): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());
        const res = await api.post(`/mpoi/save-mpoi-reporting-data`, {
          request_uuid: mpoi.request_uuid,
          customer_policy_id: mpoi.customer_policy_id,
          customer_id: mpoi.customer_id,
          from_date: fromDate,
          to_date: toDate,
          page_no: pageNumber,
          item_per_page: rowsInPerPage,
        });
        dispatch(
          showMessage({
            type: "success",
            message: "MPOI Report created successfully!",
            displayAs: "snackbar",
          })
        );
        onCallback(true);
      } catch (err: any) {
        onCallback(false);
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };


export const FETCH_MPOI_REPORT_LIST_PROGRESS = "FETCH_MPOI_REPORT_LIST_PROGRESS";
export const FETCH_MPOI_REPORT_LIST_SUCCESS = "FETCH_MPOI_REPORT_LIST_SUCCESS";
export const FETCH_MPOI_REPORT_LIST_FAILED = "FETCH_MPOI_REPORT_LIST_FAILED";

export const fetchMpoiReportListProgress = () =>
  action(FETCH_MPOI_REPORT_LIST_PROGRESS);
export const fetchMpoiReportListSuccess = (
  data: IMPOIReport[],
) =>
  action(FETCH_MPOI_REPORT_LIST_SUCCESS, {
    data,
  });
export const fetchMpoiReportListFailed = () =>
  action(FETCH_MPOI_REPORT_LIST_FAILED);

export const fetchMpoiReportListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    requestUuid: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchMpoiReportListProgress());

      let finalUrl = `/mpoi/get-mpoi-reporting-data?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}&request_uuid=${requestUuid}`;
      if (searchValue.length > 0) {
        finalUrl = `/mpoi/get-mpoi-reporting-data?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&request_uuid=${requestUuid}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      // if (customerPolicyId) {
      //   const filterObj = {
      //     column: ["customer_policy_id"],
      //     operator: "EQUAL",
      //     value: customerPolicyId,
      //     logicalOperator: "AND",
      //   };
      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += "&advanceFilter=" + encodedFilter;
      // }
      const res = await makeApiCall({
        method: "GET",
        url: finalUrl,
      });
      const data: IMPOIReport[] = res.data.data;

      dispatch(fetchMpoiReportListSuccess(data));
    } catch (err: any) {
      dispatch(fetchMpoiReportListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };


export const FETCH_MPOI_PROGRESS = "FETCH_MPOI_PROGRESS";
export const FETCH_MPOI_SUCCESS = "FETCH_MPOI_SUCCESS";
export const FETCH_MPOI_FAILED = "FETCH_MPOI_FAILED";

export const fetchMpoiProgress = () => action(FETCH_MPOI_PROGRESS);
export const fetchMpoiSuccess = (data: IMPOI) =>
  action(FETCH_MPOI_SUCCESS, {
    data,
  });
export const fetchMpoiFailed = (errorMessage: string) =>
  action(FETCH_MPOI_FAILED, { errorMessage });

export const fetchMpoiAsync =
  (
    requestUuid: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchMpoiProgress());

      const finalUrl = `/mpoi/get-eslip-payload?request_uuid=${requestUuid}`;


      const res = await api.get(finalUrl);
      const data: IMPOI[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchMpoiSuccess(data[0]));
      } else {
        dispatch(fetchMpoiFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
      }
    } catch (err: any) {
      dispatch(fetchMpoiFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

// export const FETCH_MANAGE_CSIO_EDOCS_PROGRESS =
//   "FETCH_MANAGE_CSIO_EDOCS_PROGRESS";
// export const FETCH_MANAGE_CSIO_EDOCS_SUCCESSS =
//   "FETCH_MANAGE_CSIO_EDOCS_SUCCESSS";
// export const FETCH_MANAGE_CSIO_EDOCS_FAILED = "FETCH_MANAGE_CSIO_EDOCS_FAILED";

// export const fetchManageCsioEdocsProgress = () =>
//   action(FETCH_MANAGE_CSIO_EDOCS_PROGRESS);
// export const fetchManageCsioEdocsSuccess = (data: ICSIOEDocs) =>
//   action(FETCH_MANAGE_CSIO_EDOCS_SUCCESSS, { data });
// export const fetchManageCsioEdocsFailed = (error?: string) =>
//   action(FETCH_MANAGE_CSIO_EDOCS_FAILED, { error });

// export const fetchManageCsioEdocsAsync =
//   (messageGUid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
//   async (dispatch, getState) => {
//     try {
//       dispatch(fetchManageCsioEdocsProgress());

//       const res = await makeApiCall({
//         method: "GET",
//         url: `/csio/get-csio-retrieve-messages?message_guid=${messageGUid}`,
//       });

//       if (res && res.data && res.data.data) {
//         const data = res.data.data;

//         if (data.length > 0) {
//           const { xml_json_message, attachment } = data[0];
//           try {
//             const parsedData = JSON.parse(xml_json_message);
//             const result = transformCSIOToOurEDOCS(parsedData, attachment);
//             const enhancedresult = { ...result, attachment };
//             dispatch(fetchManageCsioEdocsSuccess(enhancedresult));
//           } catch (parseError) {
//             dispatch(
//               fetchManageCsioEdocsFailed("Failed to parse JSON message")
//             );
//           }
//         } else {
//           console.log("No record found.");
//           dispatch(fetchManageCsioEdocsFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
//         }
//       } else {
//         console.log("No record found in response data.");
//         dispatch(fetchManageCsioEdocsFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
//       }
//     } catch (err: any) {
//       console.error("Fetch error:", err);
//       dispatch(fetchManageCsioEdocsFailed());
//       dispatch(
//         showMessage({
//           type: "error",
//           message: err.response.data.message,
//           displayAs: "snackbar",
//         })
//       );
//     }
//   };

export const upsertMpoiAsync =
  (
    data: IMPOI,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
    //   const asPayload = {
    //     policy_number: data.policy_number,
    //   };
    //   const path = await uploadFile(
    //     file,
    //     "CSIO",
    //     data.attachment || "",
    //     asPayload
    //   );
      await makeApiCall(
        {
          url: "/mpoi/fetch-eSlip",
          method: "POST",
          // automation: {
          //   isUpdate: isUpdate,
          //   primaryFieldName: "brokerage_equipment_code",
          // },
        },
        {},
        {
          ...data,
        //   attachment: path,
        }
      );

      dispatch(
        showMessage({
          type: "success",
          message: "MPOI saved successfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_MPOI_REPORT_LIST_STATE = "CLEAR_MPOI_REPORT_LIST_STATE";
export const clearMpoiReportListState = () => action(CLEAR_MPOI_REPORT_LIST_STATE);

export const CLEAR_MPOI_LIST_STATE = "CLEAR_MPOI_LIST_STATE";
export const clearMpoiListState = () => action(CLEAR_MPOI_LIST_STATE);
